if(!customElements.get('payment-method-component')) {
    class PaymentMethodComponent extends HTMLElement {
        constructor() {
            super();
            this.btnsSelectType = Array.from(this.querySelectorAll('[data-payment-select-type]'));
            this.groupBtnsType = Array.from(this.querySelectorAll('[data-buttons-type]'));
            this.btnsCardSelector = Array.from(this.querySelectorAll('[data-card-selector]'));
            this.items = Array.from(this.querySelectorAll('[data-payment-item]'));

            this.init();
        }

        init() {
            this.btnsCardSelector.forEach(button => {
                button.addEventListener('click', () => this.handleCardSelectorClick(button));
            });

            this.btnsSelectType.forEach(button => {
                button.addEventListener('click', () => this.handleSelectTypeClick(button));
            });

            if (this.btnsSelectType.length) this.handleSelectTypeClick(this.btnsSelectType[0]);
        }

        handleCardSelectorClick(button) {
            this.setActive(this.btnsCardSelector, button);
            this.showPaymentItem(button.getAttribute('data-card-selector'));
        }

        handleSelectTypeClick(button) {
            const selectedType = button.getAttribute('data-payment-select-type');
            this.setActive(this.btnsSelectType, button);

            this.groupBtnsType.forEach(groupBtn => {
                const matched = selectedType === groupBtn.getAttribute('data-buttons-type');
                groupBtn.classList.toggle('!hidden', !matched);
                if (matched) {
                    const firstCardBtn = groupBtn.querySelector('[data-card-selector]');
                    if (firstCardBtn) this.handleCardSelectorClick(firstCardBtn);
                }
            });
        }

        setActive(elements, activeElement, activeClass = 'active') {
            elements.forEach(el => el.classList.toggle(activeClass, el === activeElement));
        }

        showPaymentItem(cardHandle) {
            this.items.forEach(item =>
                item.classList.toggle('active', cardHandle === item.getAttribute('data-payment-item'))
            );
        }
    }
 
    customElements.define('payment-method-component', PaymentMethodComponent);
}